import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MegaScreenerMetadata {
  responseId: string;
  screenerStartDate: string;
  screenerEndDate?: string;
  isMultiTaRouting?: boolean;
}

export interface MegaScreenerOutcomeParameter {
  key: string;
  value: string;
  isPII: boolean;
}

export interface MegaScreenerQuestionAnswer {
  question: string;
  answer: string | string[];
}

export interface MegaScreenerState {
  screenerMetadata: MegaScreenerMetadata | null;
  screenerOutcomeParameter: MegaScreenerOutcomeParameter[] | null;
  allScreenerResponse: MegaScreenerQuestionAnswer[] | null;
  lastScreenerResponse: MegaScreenerQuestionAnswer[] | null;
}

const initialState: MegaScreenerState = {
  screenerMetadata: null,
  screenerOutcomeParameter: null,
  allScreenerResponse: null,
  lastScreenerResponse: null,
};

const megaScreenerSlice = createSlice({
  name: 'megaScreener',
  initialState,
  reducers: {
    setMegaScreenerSessionStarted: (
      state,
      action: PayloadAction<{ screenerMetadata: MegaScreenerMetadata }>
    ) => {
      state.screenerMetadata = action.payload.screenerMetadata;
    },
    setMegaScreenerSessionCompleted: (
      state,
      action: PayloadAction<{
        screenerMetadata: MegaScreenerMetadata;
        screenerOutcomeParameter: MegaScreenerOutcomeParameter[];
        allScreenerResponse: MegaScreenerQuestionAnswer[];
        lastScreenerResponse: MegaScreenerQuestionAnswer[];
      }>
    ) => {
      state.screenerMetadata = action.payload.screenerMetadata;
      state.screenerOutcomeParameter = action.payload.screenerOutcomeParameter;
      state.allScreenerResponse = action.payload.allScreenerResponse;
      state.lastScreenerResponse = action.payload.lastScreenerResponse;
    },
    resetMegaScreenerState: () => initialState,
  },
});

export const {
  setMegaScreenerSessionStarted,
  setMegaScreenerSessionCompleted,
  resetMegaScreenerState,
} = megaScreenerSlice.actions;

export default megaScreenerSlice.reducer;
